import React, {useEffect, useState} from 'react';
import moment from 'moment';
import ReactMarkdown from "react-markdown";
import {useDispatch, useSelector} from "react-redux";

// Icon & Framework
import * as Icon from 'ubs-icons';
import UCustomScrollBar from 'ubs-framework/v2/UCustomScrollBar';
import {fixed} from "ubs-framework/v2/common/function";
import {COLOR, FORMAT} from "ubs-framework/v2/common/constant";

// Framework Component
import UModal from "ubs-framework/v2/UModal/NewUModal";

// Component
import ViewRelease from "../common/view-release";

import {sendData} from "../../../store/actions";
import useSocket from "../../common/hooks/useSocket";

const ReleaseNotePopup = () => {
    const DISPATCH = useDispatch();

    const _R = useSelector(e => e.common.release);

    const [view, setView] = useState(null)
    const [info, setInfo] = useState(null)

    const {on, off, refresh} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'getVersionInfo': {
                    setInfo(res.data)
                    off()
                    break;
                }
                default:
                    return true;
            }
        }
    })
    useEffect(() => {
        if (_R?.release?._id) {
            refresh()
            sendData('getVersionInfo', {versionId: _R?.release?._id})
        }
        return () => off()
    }, [_R?.release?._id])

    const close = () => {
        DISPATCH({type:'CLOSE_RELEASENOTE_POPUP', payload: false})
    }
    return (
        <div className="u_release-note">
            <UModal
                open={true}
                maxWidth={680}
                close={() => close()}
                header={
                    <div className="u_flex u_align-center">
                        {view && <div className="u_release-note-back u_mr-10" onClick={() => setView(null)}><Icon.RightArrow size={14} fill={COLOR.u_blue}/></div>}
                        <h4>Version 5.{fixed(info?.release?.version, 1)} <span className="u_model-header">{moment(info?.release?.date).format(FORMAT.DUE_DATE)}</span></h4>
                    </div>
                }
            >

                {view ? <ViewRelease data={[view]}/> : <div className="u_h-500">
                    <UCustomScrollBar>
                        <div className="u_release-note-header u_p-30">
                            <div className="u_rn-img">
                                <img src="/images/latest-release.png" alt="Latest Release"/>
                            </div>
                            {info?.release.url && <div className="u_rn-video u_flex u_align-center">
                                <div className="u_release-play"><span/></div>
                                <h3 className="u_pl-12">Watch Video</h3>
                            </div>}
                        </div>
                        <div className="u_release-note-container">
                            {info?.info?.map(data => {
                                return <div className={`u_feature ${data?.type === 'BUG' ? 'u_feature__bug' : data?.type === 'NEW' ? 'u_feature__new' : 'u_feature__enhancement'}`}>
                                    <div className="u_rn-icon"><Icon.Forward size={18} fill={COLOR.u_blue}/></div>
                                    <div className="u_rn-text">
                                        <div className="u_flex u-align-center u_mb-5"><h2 onClick={() => setView(data)}>{data?.title}</h2>
                                            <span className={data?.type === 'BUG' ? 'u_rn-text-bug' : data?.type === 'NEW' ? 'u_rn-text-new' : 'u_rn-text-enhancement'}>{data?.type}</span>
                                        </div>
                                        <p className="u_two-line"><ReactMarkdown>{data?.description}</ReactMarkdown></p>
                                    </div>
                                </div>
                            })}
                        </div>
                    </UCustomScrollBar>
                </div>}

            </UModal>
        </div>
    );
};

export default ReleaseNotePopup;